export const client: RECO.Mobile.Config.Client = (window["client"] = {
    title: "奉贤科技创新管理服务信息系统",
    techSupport: "技术支持:  上海瑞谷拜特软件技术有限公司",
    urlArgs: "v=180427",
    tel: "021-20231080",
    /**
     * 作为区分同一域名下不同网页的缓存的关键字
     */
    appDomain: "biparkall_web",
    /**
     * 是否开启认证完整性校验
     */
    enableAuthIntegrity: true,
    ...window["client"],
    app: {
        /** 是否开启行政审批 */
        openAdminiApproval: false,
        /** 是否开启招聘 */
        openRecruit: false,
        /** 是否开启企业主页 */
        openEnterpriseHome: false,
        /** 是否政策申报 */
        openPolicyDeclare: false,
        /** 注册是否跳过短信验证：true 确认密码+账密注册；false 短信验证码 */
        skipRegisterSms: true,
    },
    evnFlag: 1, // 1正式  0测试
});

export const server: RECO.Mobile.Config.Server = (window["server"] = {
    apiKey: {
        apiKey: "Bitech\\PC",
        secret: "44678314ba0efa0c",
    },
    apiVersion: 9,
    auth: {
        oauth2Url: "authorization/oauth2",
        autoLogin: !0,
        autoRefreshToken: !0,
        anonymousLogin: !0,
    },
    rsa: {
        enable: true,
        publicKey: `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDXu1ms9TrhrMlIn3iv4g2Pw9Mfr9abdAB-TpDD65G98wjHZxgkZfhzUHE8BSsUDzIHfOiCd4RT5fZtTiop9bzwecgYCrAICjrVC-8ZWKf1RqRX4EXiISyEBHb4YAER_Rt2TQEWGPCi14ujDTA9qr1_YRUFfh52nrc-MfkfC12BwQIDAQAB`,
    },
    // appdownURL: "//demo.bitech.cn/iparkappjavaall/", // app下载地址
    // jsonURL: "//dev.bitechdevelop.com/reco.ipark.cms/webSeo.json", // seo生成json文件路径

    // webappurl:, // 后台地址
    // assetsUrl: , // 图片存放地址，用于富文本中获取图片
    // url: , // 本地

    webappurl: client["evnFlag"] === 1 ? "https://fxkjxmxt.cn/webapp/" : "https://app.bitechdevelop.com/fxkwpas-webapp/", // 后台地址
    assetsUrl: client["evnFlag"] === 1 ? "https://fxkjxmxt.cn/mobileapi/" : "https://app.bitechdevelop.com/fxkwpas-mobileapi/", // 图片存放地址，用于富文本中获取图片
    url: client["evnFlag"] === 1 ? "https://fxkjxmxt.cn/mobileapi/" : "https://app.bitechdevelop.com/fxkwpas-mobileapi/",
    // url: "http://localhost:8080/", // 本地

    isPhoneLogin: false,

    ...window["server"],
});
